import axios from 'axios'
import { API_URL } from '../apiUrl.js'

import {
  GET_SALE_ITEM_REQUEST,
  GET_SALE_ITEM_SUCCESS,
  GET_SALE_ITEM_FAIL
} from '../constants/saleConstants'

import {
  SCAN_USER_QR_REQUEST,
  SCAN_USER_QR_SUCCESS,
  SCAN_USER_QR_FAILED,
  GENERATE_RECEIPT_REQUEST,
  GENERATE_RECEIPT_SUCCESS,
  GENERATE_RECEIPT_FAILED,
  RETURNS_REQUEST,
  RETURNS_SUCCESS,
  RETURNS_FAILED
} from '../constants/posConstants'

// Get all sale items
export const salesList =
  (pageNumberpos = '', wordradio = '') =>
  async (dispatch) => {
    let keyword = wordradio.slice(0, -1)
    let radioValue = wordradio.slice(-1)
    let field

    axios.defaults.withCredentials = true

    try {
      dispatch({ type: GET_SALE_ITEM_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      if (radioValue === '1') {
        field = 'upc'
        const { data } = await axios.get(
          ` ${API_URL}/pos/list?pageNumberpos=${pageNumberpos}&keyword=${keyword}&field=${field}`,
          config
        )
        dispatch({ type: GET_SALE_ITEM_SUCCESS, payload: data })
      } else if (radioValue === '2') {
        field = 'manufacturer'
        const { data } = await axios.get(
          ` ${API_URL}/pos/list?pageNumberpos=${pageNumberpos}&keyword=${keyword}&field=${field}`,
          config
        )
        dispatch({ type: GET_SALE_ITEM_SUCCESS, payload: data })
      } else if (radioValue === '3' || radioValue === '') {
        field = 'subname'
        const { data } = await axios.get(
          ` ${API_URL}/pos/list?pageNumberpos=${pageNumberpos}&keyword=${keyword}&field=${field}`,
          config
        )
        dispatch({ type: GET_SALE_ITEM_SUCCESS, payload: data })
      }
    } catch (err) {
      dispatch({
        type: GET_SALE_ITEM_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message
      })
    }
  }

// Scan user QR code
export const qrscan = (qrid, vfname) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: SCAN_USER_QR_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.post(
      `${API_URL}/uqrcodes/pos`,
      { qrid, vfname },
      config
    )

    dispatch({ type: SCAN_USER_QR_SUCCESS, payload: data })
    localStorage.setItem('qrcodeScan', JSON.stringify(data))
  } catch (err) {
    dispatch({
      type: SCAN_USER_QR_FAILED,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

// Generate receipt
export const generateReceipt =
  (elementspkg, outSidedata) => async (dispatch) => {
    axios.defaults.withCredentials = true

    const { qrid, qfname, cid, barcode } = outSidedata

    try {
      dispatch({ type: GENERATE_RECEIPT_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const { data } = await axios.put(
        `${API_URL}/pos/generate/?cid=${cid}&qfname=${qfname}&barcode=${barcode}&qrid=${qrid}`,
        elementspkg,
        config
      )

      dispatch({ type: GENERATE_RECEIPT_SUCCESS, payload: data })
    } catch (err) {
      dispatch({
        type: GENERATE_RECEIPT_FAILED,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message
      })
    }
  }

// Get receipt for returns
export const getreturnsReceipt = (barcode, cid) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: RETURNS_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(
      `${API_URL}/pos/returns?barcode=${barcode}&cid=${cid}`,
      config
    )

    dispatch({ type: RETURNS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: RETURNS_FAILED,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}

// Update receipt for returns
export const returnsUpdate = (returninfo) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: 'RETURNS_UPDATE_REQUEST' })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.put(
      `${API_URL}/pos/returns/update`,
      returninfo,
      config
    )

    dispatch({ type: 'RETURNS_UPDATE_SUCCESS', payload: data })
  } catch (err) {
    console.error(err)
    dispatch({
      type: 'RETURNS_UPDATE_FAILED',
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
    })
  }
}
